export const BASELINE_VIEW = "base";
export const WORKSPACE_VIEW = "workspace";
export const CONTEXT_BASELINE = "baseline";
export const CONTEXT_WORKSPACE = "workspace";
